"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@rradar/core");
var React = require("react");
var PrimaryButton = function (props) {
    return (React.createElement(core_1.Button, { buttonType: "primary", disabled: props.primaryDisabled, onClick: function () { return props.primaryFunction(); } }, props.primaryText));
};
exports.default = PrimaryButton;
